/* ==========================================================================
   Shopify cart + predictive search.
   Replaces the localStorage cart used by the static demo with the real
   /cart.js AJAX API. Everything degrades to normal form posts without JS.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var CFG = window.BURAQ_CFG || {};

  /* Shopify money formatting — mirrors the shop's money_format string. */
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    function fmtNum(n, dec, thousand, decimal) {
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var head = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + (thousand || ','));
      return head + (parts[1] ? (decimal || '.') + parts[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount':                 return fmtNum(cents, 2, ',', '.');
        case 'amount_no_decimals':      return fmtNum(cents, 0, ',', '.');
        case 'amount_with_comma_separator':    return fmtNum(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return fmtNum(cents, 0, '.', ',');
        default:                        return fmtNum(cents, 2, ',', '.');
      }
    });
  }

  function toast(msg) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
      'stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg><span></span>';
    el.querySelector('span').textContent = msg;
    el.setAttribute('data-show', 'true');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.setAttribute('data-show', 'false'); }, 2600);
  }

  function openCart() {
    var panel = $('#cartPanel');
    if (!panel) return;
    var scrim = $('.scrim');
    panel.setAttribute('data-open', 'true');
    if (scrim) scrim.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
  }

  /* ---------------------------------------------------------------- render */
  function render(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      if (cart.item_count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });

    $$('[data-cart-lines]').forEach(function (wrap) {
      wrap.innerHTML = cart.items.map(function (i) {
        var img = i.image ? i.image.replace(/(\.[^.]*)$/, '_120x$1') : '';
        return '<div class="cline" data-key="' + i.key + '">' +
          (img ? '<img src="' + img + '" alt="" loading="lazy" width="62" height="62">'
               : '<span class="cline__noimg"></span>') +
          '<div><a class="cline__name" href="' + i.url + '">' + i.product_title + '</a>' +
          (i.variant_title && i.variant_title !== 'Default Title'
             ? '<div class="cline__variant">' + i.variant_title + '</div>' : '') +
          '<div class="cline__price">' + money(i.final_line_price) + '</div>' +
          '<div class="cline__qty">' +
            '<button data-line-dec="' + i.key + '" aria-label="Decrease quantity">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg></button>' +
            '<span>' + i.quantity + '</span>' +
            '<button data-line-inc="' + i.key + '" aria-label="Increase quantity">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>' +
          '</div></div>' +
          '<button class="cline__rm" data-line-rm="' + i.key + '">Remove</button>' +
          '</div>';
      }).join('');
    });

    $$('[data-cart-total]').forEach(function (el) { el.textContent = money(cart.total_price); });
    $$('[data-cart-empty]').forEach(function (el) { el.style.display = cart.item_count ? 'none' : ''; });
    $$('[data-cart-foot]').forEach(function (el) {
      if (cart.item_count) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });

    var threshold = CFG.freeShip || 0;
    $$('[data-ship-meter]').forEach(function (m) {
      if (!cart.item_count || !threshold) { m.setAttribute('hidden', ''); return; }
      m.removeAttribute('hidden');
      var fill = $('[data-ship-fill]', m), label = $('[data-ship-label]', m);
      if (fill) fill.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      if (label) {
        label.innerHTML = cart.total_price >= threshold
          ? 'You have unlocked <b>free delivery</b>'
          : 'Add <b>' + money(threshold - cart.total_price) + '</b> more for free delivery';
      }
    });
  }

  function fetchCart() {
    return fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); return c; });
  }

  function change(body) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (c) { render(c); return c; });
  }

  /* ---------------------------------------------------------------- events */
  function init() {
    if (!window.Shopify || !window.Shopify.routes) return;

    // add-to-cart forms (product page, quick add, bundles)
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-cart-add-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      if (btn) btn.setAttribute('disabled', '');

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) { toast(res.d.description || res.d.message || 'Could not add to cart'); return; }
          return fetchCart().then(function () {
            toast((res.d.product_title || 'Item') + ' added to cart');
            openCart();
            if (typeof window.gtag === 'function') {
              window.gtag('event', 'add_to_cart', { currency: Shopify.currency.active, value: res.d.final_price / 100 });
            }
            if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart');
          });
        })
        .catch(function () { toast('Network error — please try again'); })
        .finally(function () { if (btn) btn.removeAttribute('disabled'); });
    });

    // line-item quantity + removal
    document.addEventListener('click', function (e) {
      var inc = e.target.closest('[data-line-inc]');
      var dec = e.target.closest('[data-line-dec]');
      var rm  = e.target.closest('[data-line-rm]');
      if (!inc && !dec && !rm) return;
      e.preventDefault();

      var el = inc || dec || rm;
      var key = el.getAttribute('data-line-inc')
             || el.getAttribute('data-line-dec')
             || el.getAttribute('data-line-rm');

      var row = e.target.closest('.cline');
      var current = row ? parseInt(row.querySelector('.cline__qty span').textContent, 10) : 1;
      var next = rm ? 0 : (inc ? current + 1 : current - 1);
      change({ id: key, quantity: Math.max(0, next) });
    });

    fetchCart();
  }

  /* ------------------------------------------------------- predictive search */
  function predictive() {
    var input = $('[data-predictive-input]');
    var out = $('[data-predictive-results]');
    if (!input || !out || !window.Shopify) return;
    var timer;

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = window.Shopify.routes.root + 'search/suggest.json?q=' +
                  encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources.results.products || []);
            if (!items.length) {
              out.innerHTML = '<p class="panel__empty" style="margin:24px 0">No results</p>';
              return;
            }
            out.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? p.featured_image.url.replace(/(\.[^.?]*)(\?|$)/, '_120x$1$2') : '';
              return '<a class="search-hit" href="' + p.url + '">' +
                (img ? '<img src="' + img + '" alt="" loading="lazy">' : '<span></span>') +
                '<span><span class="search-hit__name">' + p.title + '</span><br>' +
                '<span class="search-hit__price">' + p.price + '</span></span></a>';
            }).join('');
          })
          .catch(function () {});
      }, 220);
    });

    $$('[data-search-term]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = b.getAttribute('data-search-term');
        input.dispatchEvent(new Event('input'));
        input.focus();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); predictive(); });
  } else {
    init(); predictive();
  }
})();
